import _toConsumableArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { deepMix } from '@antv/util';
import { format } from 'd3-format';
import { indexOf, mapObject } from '../utils/array';
import { composeAsync, defined, isStrictObject, isUnset } from '../utils/helper';
import { isFullTooltip } from '../utils/mark';
import { useLibrary } from './library';
import { createColumnOf } from './mark';
import { isPosition } from './scale';
// @todo Add more defaults.
export function applyDefaults(I, mark, context) {
  var _mark$encode = mark.encode,
    encode = _mark$encode === void 0 ? {} : _mark$encode,
    _mark$scale = mark.scale,
    scale = _mark$scale === void 0 ? {} : _mark$scale,
    _mark$transform = mark.transform,
    transform = _mark$transform === void 0 ? [] : _mark$transform,
    rest = __rest(mark, ["encode", "scale", "transform"]);
  return [I, Object.assign(Object.assign({}, rest), {
    encode: encode,
    scale: scale,
    transform: transform
  })];
}
export function applyDataTransform(I, mark, context) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var library, data, _useLibrary, _useLibrary2, useData, descriptor, _descriptor$transform, T, connector, transform, transformFunctions, transformedData, newData;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          library = context.library;
          data = mark.data;
          _useLibrary = useLibrary('data', library), _useLibrary2 = _slicedToArray(_useLibrary, 1), useData = _useLibrary2[0];
          descriptor = normalizedDataSource(data);
          _descriptor$transform = descriptor.transform, T = _descriptor$transform === void 0 ? [] : _descriptor$transform, connector = __rest(descriptor, ["transform"]);
          transform = [connector].concat(_toConsumableArray(T));
          transformFunctions = transform.map(useData);
          _context.next = 9;
          return composeAsync(transformFunctions)(data);
        case 9:
          transformedData = _context.sent;
          // Maintain the consistency of shape between input and output data.
          // If the shape of raw data is like { value: any }
          // and the returned transformedData is Object,
          // returns the wrapped data: { value: transformedData },
          // otherwise returns the processed tabular data.
          newData = data && !Array.isArray(data) && !Array.isArray(transformedData) ? {
            value: transformedData
          } : transformedData;
          return _context.abrupt("return", [Array.isArray(transformedData) ? indexOf(transformedData) : [], Object.assign(Object.assign({}, mark), {
            data: newData
          })]);
        case 12:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
}
export function flatEncode(I, mark, context) {
  var encode = mark.encode;
  if (!encode) return [I, mark];
  var flattenEncode = {};
  for (var _i = 0, _Object$entries = Object.entries(encode); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
      key = _Object$entries$_i[0],
      value = _Object$entries$_i[1];
    if (Array.isArray(value)) {
      for (var i = 0; i < value.length; i++) {
        var name = "".concat(key).concat(i === 0 ? '' : i);
        flattenEncode[name] = value[i];
      }
    } else {
      flattenEncode[key] = value;
    }
  }
  return [I, Object.assign(Object.assign({}, mark), {
    encode: flattenEncode
  })];
}
export function inferChannelsType(I, mark, context) {
  var encode = mark.encode,
    data = mark.data;
  if (!encode) return [I, mark];
  var typedEncode = mapObject(encode, function (channel) {
    if (isTypedChannel(channel)) return channel;
    var type = inferChannelType(data, channel);
    return {
      type: type,
      value: channel
    };
  });
  return [I, Object.assign(Object.assign({}, mark), {
    encode: typedEncode
  })];
}
export function maybeVisualChannel(I, mark, context) {
  var encode = mark.encode;
  if (!encode) return [I, mark];
  var newEncode = mapObject(encode, function (channel, name) {
    var type = channel.type;
    if (type !== 'constant' || isPosition(name)) return channel;
    return Object.assign(Object.assign({}, channel), {
      constant: true
    });
  });
  return [I, Object.assign(Object.assign({}, mark), {
    encode: newEncode
  })];
}
export function extractColumns(I, mark, context) {
  var encode = mark.encode,
    data = mark.data;
  if (!encode) return [I, mark];
  var library = context.library;
  var columnOf = createColumnOf(library);
  var valuedEncode = mapObject(encode, function (channel) {
    return columnOf(data, channel);
  });
  return [I, Object.assign(Object.assign({}, mark), {
    encode: valuedEncode
  })];
}
/**
 * Normalize mark.tooltip to {title, items}.
 */
export function normalizeTooltip(I, mark, context) {
  var _mark$tooltip = mark.tooltip,
    tooltip = _mark$tooltip === void 0 ? {} : _mark$tooltip;
  if (isUnset(tooltip)) return [I, mark];
  if (Array.isArray(tooltip)) {
    return [I, Object.assign(Object.assign({}, mark), {
      tooltip: {
        items: tooltip
      }
    })];
  }
  if (isStrictObject(tooltip) && isFullTooltip(tooltip)) {
    return [I, Object.assign(Object.assign({}, mark), {
      tooltip: tooltip
    })];
  }
  return [I, Object.assign(Object.assign({}, mark), {
    tooltip: {
      items: [tooltip]
    }
  })];
}
export function extractTooltip(I, mark, context) {
  var data = mark.data,
    encode = mark.encode,
    _mark$tooltip2 = mark.tooltip,
    tooltip = _mark$tooltip2 === void 0 ? {} : _mark$tooltip2;
  if (isUnset(tooltip)) return [I, mark];
  var valueOf = function valueOf(item) {
    if (!item) return item;
    if (typeof item === 'string') {
      return I.map(function (i) {
        return {
          name: item,
          value: data[i][item]
        };
      });
    }
    if (isStrictObject(item)) {
      var field = item.field,
        channel = item.channel,
        color = item.color,
        _item$name = item.name,
        name = _item$name === void 0 ? field : _item$name,
        _item$valueFormatter = item.valueFormatter,
        valueFormatter = _item$valueFormatter === void 0 ? function (d) {
          return d;
        } : _item$valueFormatter; // Support d3-format.
      var normalizedValueFormatter = typeof valueFormatter === 'string' ? format(valueFormatter) : valueFormatter;
      // Field name.
      var definedChannel = channel && encode[channel];
      var channelField = definedChannel && encode[channel].field;
      var name1 = name || channelField || channel;
      var values = [];
      var _iterator = _createForOfIteratorHelper(I),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var i = _step.value;
          var value1 = field ? data[i][field] : definedChannel ? encode[channel].value[i] : null;
          values[i] = {
            name: name1,
            color: color,
            value: normalizedValueFormatter(value1)
          };
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return values;
    }
    if (typeof item === 'function') {
      var _values = [];
      var _iterator2 = _createForOfIteratorHelper(I),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _i2 = _step2.value;
          var v = item(data[_i2], _i2, data, encode);
          if (isStrictObject(v)) _values[_i2] = v;else _values[_i2] = {
            value: v
          };
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return _values;
    }
    return item;
  };
  var title = tooltip.title,
    _tooltip$items = tooltip.items,
    items = _tooltip$items === void 0 ? [] : _tooltip$items,
    rest = __rest(tooltip, ["title", "items"]);
  var newTooltip = Object.assign({
    title: valueOf(title),
    items: Array.isArray(items) ? items.map(valueOf) : []
  }, rest);
  return [I, Object.assign(Object.assign({}, mark), {
    tooltip: newTooltip
  })];
}
export function maybeArrayField(I, mark, context) {
  var encode = mark.encode,
    rest = __rest(mark, ["encode"]);
  if (!encode) return [I, mark];
  var columns = Object.entries(encode);
  var arrayColumns = columns.filter(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      channel = _ref2[1];
    var V = channel.value;
    return Array.isArray(V[0]);
  }).flatMap(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
      key = _ref4[0],
      V = _ref4[1];
    var columns = [[key, new Array(I.length).fill(undefined)]];
    var rows = V.value,
      rest = __rest(V, ["value"]);
    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];
      if (Array.isArray(row)) {
        for (var j = 0; j < row.length; j++) {
          var column = columns[j] || ["".concat(key).concat(j), new Array(I).fill(undefined)];
          column[1][i] = row[j];
          columns[j] = column;
        }
      }
    }
    return columns.map(function (_ref5) {
      var _ref6 = _slicedToArray(_ref5, 2),
        key = _ref6[0],
        value = _ref6[1];
      return [key, Object.assign({
        type: 'column',
        value: value
      }, rest)];
    });
  });
  var newEncode = Object.fromEntries([].concat(columns, _toConsumableArray(arrayColumns)));
  return [I, Object.assign(Object.assign({}, rest), {
    encode: newEncode
  })];
}
export function addGuideToScale(I, mark, context) {
  var _mark$axis = mark.axis,
    axis = _mark$axis === void 0 ? {} : _mark$axis,
    _mark$legend = mark.legend,
    legend = _mark$legend === void 0 ? {} : _mark$legend,
    _mark$slider = mark.slider,
    slider = _mark$slider === void 0 ? {} : _mark$slider,
    _mark$scrollbar = mark.scrollbar,
    scrollbar = _mark$scrollbar === void 0 ? {} : _mark$scrollbar;
  var normalize = function normalize(guide, channel) {
    if (typeof guide === 'boolean') return guide ? {} : null;
    var eachGuide = guide[channel];
    return eachGuide === undefined || eachGuide ? eachGuide : null;
  };
  var axisChannels = typeof axis === 'object' ? Array.from(new Set(['x', 'y'].concat(_toConsumableArray(Object.keys(axis))))) : ['x', 'y'];
  deepMix(mark, {
    scale: Object.assign(Object.assign({}, Object.fromEntries(axisChannels.map(function (channel) {
      var scrollbarOptions = normalize(scrollbar, channel);
      return [channel, Object.assign({
        guide: normalize(axis, channel),
        slider: normalize(slider, channel),
        scrollbar: scrollbarOptions
      }, scrollbarOptions && {
        ratio: scrollbarOptions.ratio === undefined ? 0.5 : scrollbarOptions.ratio
      })];
    }))), {
      color: {
        guide: normalize(legend, 'color')
      },
      size: {
        guide: normalize(legend, 'size')
      },
      shape: {
        guide: normalize(legend, 'shape')
      },
      // fixme: opacity is conflict with DisplayObject.opacity
      // to be confirm.
      opacity: {
        guide: normalize(legend, 'opacity')
      }
    })
  });
  return [I, mark];
}
export function maybeNonAnimate(I, mark, context) {
  var animate = mark.animate;
  if (animate || animate === undefined) return [I, mark];
  deepMix(mark, {
    animate: {
      enter: {
        type: null
      },
      exit: {
        type: null
      },
      update: {
        type: null
      }
    }
  });
  return [I, mark];
}
function isTypedChannel(channel) {
  if (typeof channel !== 'object' || channel instanceof Date || channel === null) {
    return false;
  }
  var type = channel.type;
  return defined(type);
}
function inferChannelType(data, channel) {
  if (typeof channel === 'function') return 'transform';
  if (typeof channel === 'string' && isField(data, channel)) return 'field';
  return 'constant';
}
function isField(data, value) {
  if (!Array.isArray(data)) return false;
  return data.some(function (d) {
    return d[value] !== undefined;
  });
}
function normalizedDataSource(data) {
  // Return null as a placeholder.
  if (!data) return {
    type: 'inline',
    value: null
  };
  if (Array.isArray(data)) return {
    type: 'inline',
    value: data
  };
  var _data$type = data.type,
    type = _data$type === void 0 ? 'inline' : _data$type,
    rest = __rest(data, ["type"]);
  return Object.assign(Object.assign({}, rest), {
    type: type
  });
}